import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import ProtectedRoute from '../components/ProtectedRoute';
import { useAuth } from '../contexts/AuthContext';

/**
 * Create Article Page Component
 * Subscribers only
 */
const CreateArticle = () => {
  const { user } = useAuth();
  const { canAccessPremium } = useSubscription();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    category: 'Technology',
    content: '',
    status: 'Draft'
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canAccessPremium()) {
      setMessage('Premium subscription required to create articles');
      return;
    }

    if (!formData.title || !formData.content) {
      setMessage('Please fill in all required fields');
      return;
    }

    // Mock article creation - in real app, this would save to backend
    setMessage('Article created successfully! (Demo mode - article not saved)');
    
    setTimeout(() => {
      navigate('/articles');
    }, 2000);
  };

  if (!canAccessPremium()) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <div className="card">
          <h2 style={{ marginBottom: '20px' }}>Premium Feature</h2>
          <p style={{ marginBottom: '20px', color: 'var(--text-dark)' }}>
            You need a Premium subscription to create articles.
          </p>
          <button onClick={() => navigate('/subscription')} className="btn btn-primary">
            Subscribe Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <ProtectedRoute>
      <div className="container" style={{ paddingTop: '30px', maxWidth: '800px' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
          ✍️ Create Article
        </h1>

        {message && (
          <div className="card" style={{ 
            background: message.includes('successfully') ? 'green' : 'var(--highlight-color)', 
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            {message}
          </div>
        )}

        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="title">Article Title *</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter article title"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="category">Category</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="Technology">Technology</option>
                <option value="Exploration">Exploration</option>
                <option value="Education">Education</option>
                <option value="News">News</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="content">Content *</label>
              <textarea
                id="content"
                name="content"
                value={formData.content}
                onChange={handleChange}
                placeholder="Write your article content here..."
                rows="15"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="Draft">Draft</option>
                <option value="Live">Live</option>
              </select>
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%', marginBottom: '10px' }}>
              {formData.status === 'Draft' ? 'Save Draft' : 'Publish Article'}
            </button>

            <p style={{ textAlign: 'center', color: 'var(--text-dark)', fontSize: '14px' }}>
              Author: {user?.name || user?.email || 'Anonymous'}
            </p>
          </form>
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default CreateArticle;
